import { Card, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
interface StatRow {
  description: string;
  value: number;
  color?: string;
}

type Props = {
  loading: boolean;
  statsHeader: string;
  statsContent: StatRow[];
};

const Stats = ({ loading, statsHeader, statsContent }: Props) => {
  return (
    <Card variant="outlined" className="flex-1">
      <div className="box-header">Stats</div>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '90%' }}>{statsHeader}</TableCell>
            <TableCell sx={{ width: '10%' }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statsContent.map(({ description, value }, index) => (
            <TableRow key={index}>
              <TableCell>{description}</TableCell>
              {!loading && (
                <TableCell>
                  <span>{value}</span>
                </TableCell>
              )}
              {loading && (
                <TableCell>
                  <Skeleton width={24} height={23} variant="rounded" />
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default Stats;
